import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ReadMoreComponent} from '../user/projects/invisible-city/read-more/read-more.component';
import {ModalController} from '@ionic/angular';
import {IntroReadMoreComponent} from './intro-read-more.component';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
})
export class IntroComponent implements OnInit {

  constructor(public translate: TranslateService,
              public modalController: ModalController,
              private router: Router) { }

  ngOnInit() {}

  navigateOnBoarding() {
    this.router.navigate(['./on-boarding']);
  }

  async readMore() {
    const modal = await this.modalController.create({
      component: IntroReadMoreComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }
}
